<template>
  <div id="app">
    <!-- || siteType == 3 -->
    <div
      style="height: 100%;"
      :class="isAiResumeDetail && path != '/interviewRoom' ? 'fix-head' : ''"
      v-if="siteType == 1 ||
          configData.is_show_jobfair == 1 ||
          (siteType == 3 && channelData.show_content == 3)"
    >
      <div
        v-if="path != '/about' && path != '/interviewRoom'"
        class="header"
        :class="isAiResumeDetail ? 'fix' : ''"
      >
        <new-header v-if="diffPage" :isOpenAi="is_open_ai" :is_ai_interview="is_ai_interview"></new-header>
        <Header v-else :yishengyice="yishengyice" />
      </div>
      <router-view />
      <div v-if="!$route.meta.isFooterFlag && !isAiResumeDetail">
        <new-footer v-if="diffPage" :sitedata="sitedata"></new-footer>
        <div v-else class="footer">
          <Footer :yishengyice="yishengyice" />
        </div>
        <div
          v-if="this.path == '/' && !diffPage"
          class="ding"
          @mouseenter="changeImageSrc('hover')"
          @mouseleave="changeImageSrc('nohover')"
        >
          <Poptip trigger="hover" width="253" placement="left">
            <div class="dingcon">
              <img
                style="height: 36px; width: 36px; margin-top: 6px"
                :src="imgsrc"
                alt=""
              />
              <p ref="image" class="lianxuus">联系我们</p>
            </div>

            <div slot="content">
              <div class="context">
                <img
                  style="height: 24px; width: 24px"
                  src="@/assets/qiye_small.png"
                  alt=""
                />
                <div style="display: flex; margin-left: 10px">
                  <p style="color: #666; font-size: 18px">企业：</p>
                  <p style="color: #333; font-size: 18px">18916565974</p>
                </div>
              </div>
              <div class="context">
                <img
                  style="height: 24px; width: 24px"
                  src="@/assets/xusheng_small.png"
                  alt=""
                />
                <div style="display: flex; margin-left: 10px">
                  <p style="color: #666; font-size: 18px">学生：</p>
                  <p style="color: #333; font-size: 18px">021-66696957</p>
                </div>
              </div>
              <div class="context">
                <img
                  style="height: 24px; width: 24px"
                  src="@/assets/gaoxiao_small.png"
                  alt=""
                />
                <div style="display: flex; margin-left: 10px">
                  <p style="color: #666; font-size: 18px">高校：</p>
                  <p style="color: #333; font-size: 18px">18618362798</p>
                </div>
              </div>
            </div>
          </Poptip>
        </div>
      </div>
    </div>
    <div v-if="siteType == 2 && configData.is_show_jobfair == 0">
      <transferlogin :configDatas="configData"></transferlogin>
    </div>
    <div v-if="siteType == 3 && channelData.show_content != 3">
      <!-- <transferlogin :configDatas="configData"></transferlogin> -->
      <login></login>
    </div>
  </div>
</template>

<script>
import Header from "@/components/public/header";
import Footer from "@/components/public/footer";
import newFooter from "@/components/public/newFooter";
import newHeader from "@/components/public/newHeader";
import Cookies from "js-cookie";
import { getsiteInfo } from "@/api/indexPage";
import transferlogin from "@/components/transferlogin/transferlogin";
import login from "@/components/login/login";

export default {
  name: "App",
  props: {
    configDatas: {
      type: Object
    }
  },
  data() {
    return {
      yishengyice: false,
      jiuyeyuren: false,
      imgsrc: require("@/assets/lianxiyi.png"),
      path: "",
      diffPage: false,
      siteType: "",
      configData: "",
      isChangeLogo: false,
      sitedata: {},
      channelData: "",
      is_open_ai: 0,
      is_ai_interview: 0
    };
  },
  components: {
    Header,
    Footer,
    newFooter,
    newHeader,
    transferlogin,
    login
  },

  watch: {
    $route: {
      handler(val, oldval) {
        console.log(222222222222);
        this.path = val.path;
        // 获取路由协议，例如 "http:" 或 "https:"
        let protocol = window.location.protocol;
        // 获取域名，例如 "www.example.com"
        let hostname = window.location.hostname;
        // 获取完整的URL地址
        let fullURL = window.location.href;
        // 端口号
        let port = window.location.port;
        // 域名与协议拼接
        let domain = protocol + "//" + hostname + (port ? ":" + port : "");
        // 参数截取
        let pattern = /\?.*/;
        let search = fullURL.match(pattern);
        search = search ? search[0] : "";
        // 实际提交内容截取
        let toPath = fullURL.replace(domain, "");
        if (search) {
          toPath = toPath.replace(search, "");
        }
        window._czc && window._czc.push(["_trackPageview", toPath]);
      },
      // 深度观察监听
      deep: true
    }
  },
  computed: {
    isAiResumeDetail() {
      if(this.$route.path == 'aiInterviewResult' || this.$route.path == "/aiResumeDetail" || this.$route.path == "/diagnosticResult" || this.$route.path == "/interviewRoom" || this.$route.path == '/aiInterviewResult' || this.$route.path == '/attentdetail') {
        return true
      }
      return false
    }
  },
  created() {
    this.getCurrentSiteinfo();
    this.path = this.$route.path;

    let yishengyice = location.host.indexOf("yishengyice.com");
    let jiuyeyuren = location.host.indexOf("jiuyeyuren.com");
    this.jiuyeyuren = jiuyeyuren !== -1;
    this.yishengyice = yishengyice !== -1;
    sessionStorage.setItem("yishengyice", yishengyice === -1 ? 0 : 1);
    console.log('==', window.location.origin.split("//")[1])
    console.log('==12', window.location.origin.split("//")[1].indexOf("localhost") > -1)
    this.diffPage =
      window.location.origin.split("//")[1].indexOf("jiuyeyuren") > -1 ||
      window.location.origin.split("//")[1].indexOf("biyeshen") > -1 ||
      window.location.origin.split("//")[1].indexOf("applyoffer") > -1 ||
      window.location.origin.split("//")[1].indexOf("localhost") > -1;
    this.isChangeLogo =
      window.location.origin.split("//")[1].indexOf("jiuyeyuren") > -1;
    console.log("this.diffPage", this.diffPage);
    sessionStorage.setItem("diffPage", this.diffPage);
    this.replaceIco();
  },
  mounted() {
    console.log(1111111111);
    var _czc = _czc || [];
    (function() {
      const id =
        process.env.NODE_ENV == "production" ? "1281352567" : "1281352592";
      var um = document.createElement("script");
      um.src = `https://s4.cnzz.com/z.js?id=${id}&async=1`;
      var s = document.getElementsByTagName("script")[0];
      s.parentNode.insertBefore(um, s);
    })();
    window._czc && window._czc.push(["_setAutoPageview", false]);
  },
  methods: {
    //动态替换图标
    replaceIco() {
      //动态更换浏览器标签页的图标
      const link =
        document.querySelector("link[rel*='icon']") ||
        document.createElement("link");
      link.type = "image/x-icon";
      link.rel = "shortcut icon";
      link.href = this.isChangeLogo
        ? "static/jiuyeyuren.ico"
        : "static/liulanqi.ico";
      document.getElementsByTagName("head")[0].appendChild(link);
    },
    changeImageSrc(key) {
      switch (key) {
        case "hover":
          this.imgsrc = require("@/assets/lianxi.png");
          this.$refs.image.style.color = "#fff";
          break;
        case "nohover":
          this.imgsrc = require("@/assets/lianxiyi.png");
          this.$refs.image.style.color = "#3B80FB";
          break;
      }
    },
    async getCurrentSiteinfo() {
      let data = {};
      // data.domain = ''
      if (process.env.NODE_ENV == "development") {
        console.log("development");
        data.domain = window.location.origin.split("//")[1];
        //开发环境
      } else if (process.env.NODE_ENV == "production") {
        //生产环境
        console.log("production");
        data.domain = "";
      } else {
        //本地环境
        console.log("本地");
      }
      await getsiteInfo(data).then(res => {
        this.is_open_ai = res.is_open_ai
        this.is_ai_interview = res.is_ai_interview
        this.sitedata = res;
        this.siteType = res.type;
        sessionStorage.setItem("siteType", this.siteType);
        this.$store.commit("header/setType", this.siteType);
        this.configData = res.school;
        this.channelData = res.channel;
        var schoolInfo = "";
        if (this.siteType == 1) {
          //主站
          schoolInfo = res.qr_parameter_id;
        } else if (this.siteType == 2) {
          schoolInfo = res.school.qr_parameter_id;
        } else {
          schoolInfo = res.channel.qr_parameter_id;
          if (res.channel.show_content == "2") {
            window.location.href = `${window.location.origin}/company/#/`;
            return;
          }
        }
        if (
          navigator.userAgent.match(
            /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|IEMobile)/i
          )
        ) {
          let domain = this.jiuyeyuren ? `jiuyeyuren` : "applyoffer";
          let page = "";
          console.log("schoolInfo", schoolInfo);
          console.log(
            "this.configData.is_show_jobfair",
            this.configData.is_show_jobfair
          );
          if (this.configData.is_show_jobfair == 0) {
            //this.siteType == 3
            console.log("关闭");
            return;
          } else {
            // if(this.siteType == 2){

            if (this.jyyr) page = "&page=position_list";
            window.location.href = `http://wxjump.${domain}.com/#/?scene=${schoolInfo}${page}`;
            // }
          }
        }
      });
    }
  }
};
</script>

<style>
html,
body {
  margin: 0;
  padding: 0;
  overflow: visible;
  padding-right: 0;
  height: 100%;
}
.fix-head {
  padding-top: 60px;
}
.header {
  height: 59px;
  /* background: pink; */
  width: 100%;
}
.header.fix {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  background: #fff;
  z-index: 999;
}
#app {
  height: 100%;
}

.ding {
  position: fixed;
  top: 60%;
  right: 0;
}

.dingcon {
  height: 92px;
  width: 92px;
  /* background: #1082ff; */
  background: #fff;
  box-shadow: 0px 2px 8px 0px rgba(15, 60, 110, 0.45);
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.dingcon:hover {
  background: #1082ff;
  transition: all 0.8s;
}

.lianxuus {
  font-size: 16px;
  font-family: MicrosoftYaHei;
  color: #3b80fb;
  margin-top: 10px;
  cursor: pointer;
}

.context {
  width: 100%;
  display: flex;
  align-items: center;
  /* justify-content: space-around; */
}

.footer {
  height: 171px;
  width: 100%;
  background: #182b4e;
}
</style>



// WEBPACK FOOTER //
// src/App.vue